import {
  AppLayout,
  Button,
  Container,
  ContentLayout,
  Header,
  HelpPanel,
  Link,
} from "@cloudscape-design/components";
import { BoardAssembly } from "./boardAssemble";
import { HomepageInformationSlider } from "./HomepageInformationSlider";
import React from "react";
import { HeaderHomePage } from "./headerHomePage";

const LOCALE = "en";

export const HomePage = () => {
  const [isToolsOpen, setIsToolsOpen] = React.useState(true);
  return (
    <AppLayout
      // Tells AppLayout how tall the shared site header above it is, so its
      // own sticky chrome starts below rather than under it.
      headerSelector="#site-header"
      headerVariant="high-contrast"
      navigationHide={true}
      toolsHide={false}
      // headerVariant="high-contrast"
      // header={<HeaderHomePage />}
      toolsOpen={isToolsOpen}
      onToolsChange={({ detail }) => setIsToolsOpen(detail.open)}
      tools={<HomepageInformationSlider />}
      maxContentWidth={Number.MAX_VALUE}
      content={
        <ContentLayout
          defaultPadding
          headerVariant="high-contrast"
          header={
       <HeaderHomePage openHelpPanel={setIsToolsOpen} />
          }
        >
          <Container>
            <BoardAssembly />
          </Container>
        </ContentLayout>
      }
    />
  );
};
